import { BrowserRouter, Navigate, useLocation } from 'react-router-dom';
import { Routes, ScrollReset } from 'components';

const CanonicalRedirect = () => {
    const location = useLocation();
    const path = location.pathname;

    if (path.length > 1 && path.endsWith('/')) {
        return <Navigate to={`${path.replace(/\/+$/, '')}${location.search}`} replace />;
    }

    if (path.toLowerCase() === '/services/pim') {
        return <Navigate to={`/pim${location.search}`} replace />;
    }

    return null;
};

function App() {
    return (
        <BrowserRouter>
            <ScrollReset />
            <CanonicalRedirect />
            <Routes />
        </BrowserRouter>
    );
}
 
export default App;
